<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Müşteri Sayısı",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        title: "MÜŞTERİ SAYISI",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ SAYISI",
          active: true,
        },
      ],
      isLoading: false,
      form:{},
      rows: {
        ADSL :{
          0:0,
          1:0,
          2:0,
          3:0,
          4:0,
          5:0
        },
        WIFI :{
          0:0,
          1:0,
          2:0,
          3:0,
          4:0,
          5:0
        }
      },
      
    };
  },
  mounted() {
    this.loadItems()
  },

  methods: {
    loadItems() {
      this.$http.post('/reports/sayilar', )
                .then(resp => { this.rows = { ...this.rows, ...resp.data} })
                .catch(error => error)
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-striped table-hover table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Wireless</th>
                  <th>Adsl</th>
                  <th>Toplam</th>
                </tr>
              </thead>
                <tbody>
                  <tr>
                      <th>Aktif</th>
                      <td> {{ rows['ADSL'][1] || "0" }} </td>
                      <td> {{ rows['WIFI'][1] || "0" }} </td>
                      <td> {{ (rows['ADSL'][1] || 0) + (rows['WIFI'][1]  || 0)  }} </td>
                  </tr>
                   <tr>
                      <th>Süresi Biten</th>
                      <td> {{ rows['ADSL'][2] || "0" }}  </td>
                      <td> {{ rows['WIFI'][2] || "0" }}  </td>
                      <td> {{ (rows['ADSL'][2] || 0) + (rows['WIFI'][2]  || 0)  }}  </td>
                  </tr>
                  <tr>
                      <th>De-Aktif</th>
                      <td> {{ rows['ADSL'][0] || "0" }} </td>
                      <td> {{ rows['WIFI'][0] || "0" }}  </td>
                      <td> {{ (rows['ADSL'][0] || 0) + (rows['WIFI'][0]  || 0)  }}  </td>
                  </tr>
                  <tr>
                      <th>Dondurulan</th>
                      <td> {{ rows['ADSL'][4] || "0" }} </td>
                      <td> {{ rows['WIFI'][4] || "0" }}  </td>
                      <td> {{ (rows['ADSL'][4] || 0) + (rows['WIFI'][4]  || 0)  }}  </td>
                  </tr>
                  <tr>
                      <th>Sökülen</th>
                      <td> {{ rows['ADSL'][3] || "0" }} </td>
                      <td> {{ rows['WIFI'][3] || "0" }}  </td>
                      <td> {{ (rows['ADSL'][3] || 0) + (rows['WIFI'][3]  || 0)  }}  </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>